import React, { Component } from 'react'
import config from '../config.json'
import addItemIdToFilter from "../functions/addItemToFilter";
import FilterResultsList from './FilterResultsList';
import OverviewTitle from './OverviewTitle';
import BackToOverview from './BackToOverview';
import WeischerItemsList from '../Weischer/WeischerItemsList';
import queryString from 'query-string'
import hasOpenInformationAndDetails from '../hoc/hasOpenInformationAndDetails';
import hasSlidebarRightAndSecond from '../hoc/hasSlidebarRightAndSecond'
import BackgroundFormatItemContainer from '../BackgroundFormatItem'
import Scroll from 'react-scroll'
import getAdvertisementData from '../functions/getAdvertisementData';
import { ADVERTISEMENT_OVERVIEW_BANNER } from '../constants/advertisementTypes';
import getWeischerData from '../functions/getWeischerData';
import AdvertisementsBannerList from '../Advertisements/AdvertisementsBannerList';
import Translation from '../General/Translation';
import getMoreMovies from '../functions/getMoreMovies';
import seperateAttributes from '../functions/seperateAttributes';


const scroller = Scroll.scroller;
class FilterResultsMovie extends Component {
    constructor(props) {
        super(props)

        this.state = { 
            titleFilter: {},
            moreMovies: null
        }
    }

    getMoviesTitleList() {
        const { routesData } = this.props
        let filterTitles = {}

        if(routesData.movies.items) {
            Object.keys(routesData.movies.items).map(movieId => {
                const { uri_path } = routesData.movies.items[movieId]
                if( uri_path ) {
                    filterTitles = addItemIdToFilter(filterTitles, uri_path, movieId)
                }
            })
        }

        return filterTitles
    }

    getMovieIds() {
        const { match, movies } = this.props
        const { titleFilter } = this.state
        let movieIds = []

        if(match.params.movieParam && titleFilter.hasOwnProperty(match.params.movieParam)) {
            const ids = titleFilter[match.params.movieParam]

            ids.map(id => {
                if(movies.order.includes(id)) {
                    movieIds.push(id)
                }
            })
        }

        return 0 == movieIds.length ? false : movieIds
    }

    movieHasPerformance(queryStringValues) {
        const {movies} = this.props
        const movieIds = this.getMovieIds()
        let relevantPerformances = []
        
        if(movieIds) {
            movieIds.map(movieId => {
                const movie = movies.items[movieId]
                
                if(movie) {
                    const {performances} = movie
                    
                    const relevantPerformance = _.find(performances, (performance => {
                        if(queryStringValues && queryStringValues.performance_id) {
                            return performance.id === queryStringValues.performance_id
                        }
                    }))
                    
                    if(relevantPerformance) {
                        const performanceData = {
                            performance: relevantPerformance,
                            movie: movie
                        }
                        relevantPerformances.push(performanceData)
                    }
                }
            })
        }

        return relevantPerformances
    }

    componentDidUpdate(prevProps) {
        const queryStringValues = queryString.parse(this.props.location.search)
        const relevantPerformancesData = this.movieHasPerformance(queryStringValues)

        if(!this.state.moreMovies) {
            const {movies} = this.props
            const movieIds = this.getMovieIds()
            const itemData = movies.items[movieIds[0]]
            const {technologyAttributes} = itemData
            const {technologyAttributesWithIcons, technologyAttributesWithoutIcons} = seperateAttributes(technologyAttributes)
            const moreMovies = getMoreMovies(itemData, movies.items, technologyAttributesWithIcons, technologyAttributesWithoutIcons)

            this.setState({
                moreMovies: moreMovies
            })
        }
        
        if(!prevProps.activePerformance && queryStringValues && queryStringValues.performance_id) {
            if(relevantPerformancesData && relevantPerformancesData.length !== 0) {
                const {performance,  movie} = relevantPerformancesData[0]
                const {id, timeUtc, deeplinkURL, cinema} = performance
                const {title, titleDisplay} = movie
                this.props.onOpenPerformancePage({
                    id: id,
                    timeUtc: timeUtc,
                    cinema: cinema,
                    url: deeplinkURL,
                    movieId: movie.pk,
                    movieTitle: titleDisplay ? titleDisplay : title
                })
                
                const performancePageElemCompeso = document.getElementById('compeso-iframe')
                const performancePageElemDiesel = document.getElementById('diesel-iframe')

                if(performancePageElemCompeso || performancePageElemDiesel) {
                    setTimeout(() => {
                        scroller.scrollTo(movie.pk + ' performance-iframe', {
                            offset: -200,
                            isDynamic: true,
                            smooth: true
                        })
                    }, 500)
                }
            }
        }
    }

    componentDidMount() {
        this.setState({
            titleFilter: this.getMoviesTitleList()
        })
    }
    
    render() {
        const { 
            activePerformance, 
            activeDetailsItem,
            movies, 
            weischerAds,
            advertisements,
            match, 
            isMobile,
            translation, 
            routesData, 
            overviewSubtitle,
            performancePageOpen, 
            displaySidebarRight, 
            onSidebarRightClose, 
            onSidebarRightOpen, 
            displaySidebarRightSecond, 
            onClosePerformancePage, 
            onOpenPerformancePage, 
            programOverviewListStyle,
            onOpenDetailsFirstSidebar,
            onCloseDetailsFirstSidebar
        } = this.props

        const movieIds = this.getMovieIds()

        if(!movieIds) {
            return (
                <div className={"overview overview-view-list movie " + programOverviewListStyle}>
                    <OverviewTitle singleMovie={false} notFound={true} translation={translation} overviewSubtitle={overviewSubtitle}/>
                    <BackToOverview translation={translation} pathname={match.params.overviewParam}/>
                </div>
            )
        }

        const {currentLang} = translation
        const { overviewWeischerAds } = getWeischerData(weischerAds)
        const filteredAdvertisements = getAdvertisementData(advertisements, [ADVERTISEMENT_OVERVIEW_BANNER]) 
        const {moreMovies} = this.state

        return (
            <div className={"overview overview-view-list movie " + programOverviewListStyle}>
                <OverviewTitle singleMovie={true} notFound={false} items={movieIds} movies={movies.items} translation={translation} />

                <BackToOverview translation={translation} pathname={match.params.overviewParam}/>

                <>
                    <WeischerItemsList weischerAdsList={overviewWeischerAds} />
                    <AdvertisementsBannerList items={filteredAdvertisements[ADVERTISEMENT_OVERVIEW_BANNER]} />
                </>

                <FilterResultsList
                    additionalScrollName=''
                    activePerformance={activePerformance}
                    activeDetailsItem={activeDetailsItem}
                    displaySidebarRight={displaySidebarRight}
                    displaySidebarRightSecond={displaySidebarRightSecond}
                    items={movieIds}
                    isMobile={isMobile}
                    itemsData={movies.items}
                    isSingleMovie={true}
                    onClosePerformancePage={onClosePerformancePage}
                    onOpenPerformancePage={onOpenPerformancePage}
                    onSidebarRightClose={onSidebarRightClose}
                    onSidebarRightOpen={onSidebarRightOpen}
                    performancePageOpen={performancePageOpen}
                    queryStringValues={{}}
                    interscrollerAdvertisements={[]}
                    interscrollerWeischerAds={[]}
                    translation={translation}
                    moviesRoutesData={routesData.movies.items}
                    onCloseDetails={onCloseDetailsFirstSidebar}
                    onOpenDetails={onOpenDetailsFirstSidebar}
                />
                {moreMovies && moreMovies.length !== 0 && <div className={'single-movie-more-movies-wrapper grid-site-wrapper ' + programOverviewListStyle}>
                    <div className='titles-wrapper'>
                        <p className="title-xlarge"><Translation id="moreMovies" trans={translation}>Weitere Filme</Translation></p>
                        {routesData && <a className="full-program-button" href={routesData.program_overview[currentLang].uri}>
                            <p><Translation className="full-program-button" id="fullProgram" trans={translation}>Komplettes Programm</Translation></p>
                            <svg id="Ebene_2" data-name="Ebene 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.99 11.49">
                                <g id="Ebene_1-2" data-name="Ebene 1">
                                    <polygon points="12.33 0 10.78 1.26 13.61 4.75 0 4.75 0 6.75 13.6 6.75 10.78 10.24 12.33 11.49 16.99 5.73 12.33 0"/>
                                </g>
                            </svg>
                        </a>}
                    </div>
                    <div className='single-movie-more-movies no_slide'> 
                        {moreMovies.map((movie, index) => { 
                            return <div key={index} className="slide-item">
                                <BackgroundFormatItemContainer
                                    itemID={movie.pk}
                                    itemData={movie}
                                    stripeAppearance={'no_slide'}
                                    showPerformances={false}
                                    scrollToPosition={movie.pk}
                                    isMobile={isMobile}
                                    queryStringValues={{}}
                                    onClickItem={()=>{}}
                                    index = {index}
                                    goToMoviepage={true}
                                />
                            </div>
                        })}
                    </div>
                </div>}
            </div>
        )
    }
}


export default hasSlidebarRightAndSecond({breakpoint:  config.breakpoints.slidebarRight})(hasOpenInformationAndDetails(FilterResultsMovie))